import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/How to communicate your vision.png')}/>
                                        </div>
                                        <div className="ilead-contentarea">
                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>isn't it interesting?
                                            </div>
                                            <p>Communicating a vision to others involves translating an abstract
                                                concept into practical activities.
                                                Consider one of the most important translations in existence –
                                                the Rosetta stone.</p>
                                            <div className="border_subtitle">Bringing people together</div>
                                            <p>The Rosetta stone is an ancient Egyptian artefact, created in 196
                                                BC. Currently in the British
                                                Museum, it features translations of a single passage in two
                                                hieroglyphic texts and Ancient Greek.
                                                In essence, the stone communicates a vision to the temple
                                                priests of a better tax system and in
                                                practice outlined restoration of tax privileges.</p>
                                            <p>Translating a successful leadership vision into clear practical
                                                actions can bring people together,
                                                give them a sense of shared purpose and make the impossible
                                                possible. Evidence from a range
                                                of studies shows that successful communication of visions
                                                depends heavily on the leader being
                                                seen as identifying with group members and having a history of
                                                standing up for the group and its
                                                members in order for the group to be prepared to do the work
                                                necessary to realise the vision.</p>
                                            <div className="lightgreencontentbg keyquestionpad ">
                                                <div className="border_subtitle">Together we stand</div>
                                                <p>Social psychologists Julie Duck and Kelly Fielding<a
                                                    className="superscripttext "
                                                    href="further_info.php?course=300"><sup>1</sup></a> found in
                                                    their research into leadership
                                                    that group members show high levels of identification with
                                                    their group when their leader is
                                                    representative of that group – whatever course of action the
                                                    leader chooses to pursue.</p>
                                                <div className="uiheading"><p>In 2001, Haslam and Platow<a
                                                    className="superscripttext "
                                                    href="further_info.php?course=300"><sup>2</sup></a> conducted
                                                    a study to investigate how social identity affects
                                                    translating visions into actions. They asked students to
                                                    rate how much they would follow
                                                    leaders based on videos of leaders outlining different
                                                    visions for their campus. They found
                                                    that students only generated arguments and ideas that backed
                                                    up a leader’s plans for
                                                    improving their campus, if that leader had a record of
                                                    making decisions that supported
                                                    positions that the group related to (e.g. opposing
                                                    government cuts).</p></div>
                                            </div>

                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}